import React from "react";
import MPFNoProductChangesSubRow from "./MPFNoProductChangesSubRow";
import MPFProductChangesSubRow from "./MPFProductChangesSubRow";
import { connect } from "react-redux";
import { NEW_PRODUCT } from "../../../../../store/wlrBroadband/constants";
import { getProducts } from "../../../../../store/wlrBroadband/selectors";
import { LineProductSelector } from "../LineProductSelector";

const MPFLineProductOverview = ({
  configuration,
  productInstance,
  removeResign,
  setChanges,
  allProducts
}) => {
  const resignProduct = allProducts.find(
    product => product.id === configuration.wlrProductId
  );
  return (
    <>
      {configuration.wlrProductId && resignProduct ? (
        <MPFProductChangesSubRow
          productInstance={productInstance}
          removeResign={removeResign}
          resignProduct={resignProduct}
          productInstanceType="wlr"
        />
      ) : (
        <MPFNoProductChangesSubRow
          productInstance={productInstance}
          configuration={configuration}
          onClick={setChanges}
          removeResign={removeResign}
          productInstanceId={configuration.wlrProductId}
          productInstanceType="wlr"
        />
      )}
      {configuration.resignProductType === NEW_PRODUCT &&
        !configuration.wlrProductId && (
          <LineProductSelector
            configuration={configuration}
            productInstance={productInstance}
          />
        )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const locationIndex = ownProps.configuration.locationIndex;
  return {
    allProducts: getProducts(state, locationIndex)
  };
};

export default connect(mapStateToProps)(MPFLineProductOverview);
